// AI Generated Test
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { PolicyRepoService } from '@client/app/services/api/policy-repo/policy-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { BaseEntityService } from '@client/app/blocks/base/base.entity.service';
import { LabelService } from '@monsido/services/label-service/label.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { ENTITY_CONSTANT } from '@client/app/core/constants/entity.constant';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'pages-policy-dialog-pages',
    standalone: false,
    template: `
        <div class="mon-dialog-header">
            <page-header panelClass="row"
                         panelLeftClass="col-32 col-md-28 col-lg-30 mt-2"
                         panelRightClass="col-16 col-md-20 col-lg-18"
                         [header]="'Content with Policy Matches' | translate">
                <page-header-content>
                    <div class="mon-dialog-delay-fadein d-flex">
                        <div class="mt-1">
                            <csv-export-button [exports]="exports"></csv-export-button>
                            <a *ngIf="'table_filters' | activeFeature"
                               (click)="isFiltersOpen = !isFiltersOpen"
                               class="text-link inline-block mt-1 cursor-pointer">
                                <span class="fas fa-filter fa-lg" aria-hidden="true"></span>
                            </a>
                        </div>
                        <div class="mt-1 pl-4 flex-fill-column-width">
                            <table-search [minSearchLength]="3"
                                          class="block mr-2"
                                          theme="grey-theme"
                                          [placeholderTxt]="'Search...' | translate"
                                          [(model)]="search"
                                          (modelChange)="onSearch($event)">
                            </table-search>
                        </div>
                    </div>
                </page-header-content>
            </page-header>
        </div>

        <div class="mon-dialog-body">
            <div class="mx-4">
                <quick-help-compliance-status type="policy"
                                              [data]="policy"
                                              [totalPagesCount]="currentPageCount"
                                              [totalPageIssues]="totalIssues">
                </quick-help-compliance-status>
            </div>
            <div class="mt-4 mx-4">
                <mon-tabs [options]="tabs" [(status)]="activeTab" (onStatus)="onStatus($event)">
                </mon-tabs>
            </div>
            <div class="card panel-monsido-card mx-4">
                <div class="card-body">
                    <div class="outer-b merge-r-16 merge-l-16 merge-t-10" *ngIf="isFiltersOpen">
                        <table-filters [(open)]="isFiltersOpen"
                                       [(ngModel)]="filters"
                                       name="filters"
                                       [filters]="availableFilters"
                                       *ngIf="'table_filters' | activeFeature"
                                       (onChanges)="onFiltersChanged($event)">
                        </table-filters>
                    </div>
                    <div class="row">
                        <div class="col-48">
                            <table-container
                                    [progress]="progress"
                                    [collection]="pages"
                                    (onPageChange)="onPageChange($event)"
                                    [noResultMessage]="'Congratulations no violations were found' | translate"
                                    (onPerPageChange)="onPageSizeChange($event)"
                                    class="pages-table-wrapper">
                                <table class="table table-hover table-fixed policy-violations-table table-with-labels">
                                    <thead>
                                    <tr>
                                        <th monTableSort
                                            [monSortBy]="'title'"
                                            [monSortDirection]="currentSort.direction"
                                            [monCurrentlySortedBy]="currentSort.by"
                                            (monOnSorted)="onMonTableSort($event)"
                                            [monThTitle]="'Title and URL' | translate">
                                        </th>
                                        <th class="text-right col-sm-4 col-md-4 col-lg-3">{{ 'Unwanted' | translate }}</th>
                                        <th class="text-right col-sm-4 col-md-4 col-lg-3">{{ 'Required' | translate }}</th>
                                        <th class="text-right col-sm-4 col-md-4 col-lg-3">
                                            {{ 'Matches' | translate }}
                                        </th>
                                        <th class="text-right col-sm-4 col-md-4 col-lg-3"
                                            *ngIf="!(activeTab === 'pdf' || activeTab === 'document')"
                                            monTableSort
                                            [monSortBy]="'priority_score'"
                                            [monSortDirection]="currentSort.direction"
                                            [monCurrentlySortedBy]="currentSort.by"
                                            (monOnSorted)="onMonTableSort($event)">
                                            {{ 'Priority' | translate }}
                                        </th>
                                        <th class="text-right col-sm-4 col-md-4 col-lg-3"
                                            *ngIf="!(activeTab === 'pdf' || activeTab === 'document') && viewsColumIsAvailable"
                                            monTableSort
                                            [monSortBy]="'hits'"
                                            [monSortDirection]="currentSort.direction"
                                            [monCurrentlySortedBy]="currentSort.by"
                                            (monOnSorted)="onMonTableSort($event)">
                                            {{ 'Views' | translate }}
                                        </th>
                                        <th class="col-sm-4 col-md-4 col-lg-6">&nbsp;</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let page of pages">
                                        <td>
                                            <div class="text-ellipsis">
                                                <mon-url-title
                                                        *ngIf="!pageDetailsIsAvailable"
                                                        [title]="page.title"
                                                        [url]="page.url"
                                                        [active]="false">
                                                </mon-url-title>
                                                <url-title-page-details
                                                        *ngIf="pageDetailsIsAvailable && page.type === 'html'"
                                                        [target]="'page-details-section-policies'"
                                                        [subTarget]="policy"
                                                        [title]="page.title"
                                                        [url]="page.url"
                                                        [page]="page"
                                                        (onClose)="onPageDetailsClose()"
                                                        [active]="false">
                                                </url-title-page-details>
                                                <url-title-document-details *ngIf="pageDetailsIsAvailable && page.type !== 'html'"
                                                                            [document]="page"
                                                                            [title]="page.title"
                                                                            [url]="page.url"
                                                                            [active]="true"
                                                                            [target]="'policies'"
                                                                            [subTarget]="policy">
                                                </url-title-document-details>
                                            </div>
                                            <label-table *ngIf="showLabels"
                                                             [assignedLabels]="page.labels"
                                                             [existingLabels]="labels"
                                                             (getLabels)="getLabels()"
                                                             (onUpdateLabel)="updateLabels(page)" />
                                        </td>
                                        <td class="inner-l-r-none text-v-middle text-right">
                                            <icon-button
                                                    faIcon="fas fa-ban"
                                                    [number]="page.policy_violation_count"
                                                    positive="text-danger"
                                                    negative="negative"
                                                    neutral="text-neutral-misspelling"
                                                    [changeTextColor]="false">
                                            </icon-button>
                                        </td>
                                        <td class="inner-l-r-none text-v-middle text-right">
                                            <icon-button
                                                    faIcon="fas fa-exclamation-triangle"
                                                    [number]="page.policy_required_count"
                                                    positive="text-orange"
                                                    negative="negative"
                                                    neutral="text-neutral-misspelling"
                                                    [changeTextColor]="false">
                                            </icon-button>
                                        </td>
                                        <td class="inner-l-r-none text-v-middle text-right">
                                            <icon-button
                                                    faIcon="fas fa-search"
                                                    [number]="page.policy_search_count"
                                                    positive="text-info"
                                                    neutral="text-neutral-misspelling"
                                                    [changeTextColor]="false">
                                            </icon-button>
                                        </td>
                                        <td *ngIf="!(activeTab === 'pdf' || activeTab === 'document')" class="text-v-middle text-right">
                                            <mon-priority class="vcenter" [priority]="page.priority_score_as_text"></mon-priority>
                                        </td>
                                        <td *ngIf="viewsColumIsAvailable && !(activeTab === 'pdf' || activeTab === 'document')" class="text-v-middle text-right">
                                            <visits [title]="page.title" [visits]="page.hits" [totalVisits]="pages.pageHits"></visits>
                                        </td>
                                        <td class="d-flex align-items-end justify-content-end flex-wrap">
                                            <table-page-details
                                                    *ngIf="page.type === 'html'"
                                                    [ngbTooltip]="'Open page details' | translate"
                                                    [triggers]="'focus hover'"
                                                    [target]="'page-details-section-policies'"
                                                    [subTarget]="policy"
                                                    [page]="page">
                                            </table-page-details>
                                            <table-document-details
                                                    *ngIf="page.type !== 'html'"
                                                    [ngbTooltip]="'Open document details' | translate"
                                                    [triggers]="'focus hover'"
                                                    target="policies"
                                                    [subTarget]="policy"
                                                    [document]="page"
                                                    (callBack)="onPageDetailsClose()">
                                            </table-document-details>
                                            <mon-extension-visual-link-button class="ml-1" [page]="page" [type]="'pol'"></mon-extension-visual-link-button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </table-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class PagesPolicyDialogPagesComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    @Input() policy: any;
    @Input() pageCount: any;
    @Input() contentCount: any;
    @Input() pdfCount: any;
    @Input() documentCount: any;

    pages: any = [];
    tabs: any;
    totalIssues: any;
    currentPageCount: any = 0;
    viewsColumIsAvailable: boolean = false;
    pageDetailsIsAvailable: boolean = false;
    exports: any = [];
    progress: any;
    eventId: any;

    constructor (
        private policyRepoService: PolicyRepoService,
        private translateService: TranslateService,
        private monEventService: MonEventService,
        private baseEntityService: BaseEntityService,
        private labelService: LabelService,
        private activeFeatureService: ActiveFeatureService,
    ) {
        super({ table: true, labels: true, pages: true });
    }

    ngOnInit (): void {
        this.eventId = this.monEventService.addListener(
            ENTITY_CONSTANT.PAGE_UPDATED_EVENT as any,
            this.baseEntityService.updateEntryInArray(this, 'pages', 'id'),
        );

        this.viewsColumIsAvailable = this.activeFeatureService.isFeatureActive('script_setup_guide');
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');
        this.totalIssues = this.policy.pages_count;
        this.currentSort = { by: 'priority_score', direction: 'desc' };
        this.pages = [];

        this.tabs = [
            {
                name: this.translateService.getString('All'),
                faIcon: 'fas fa-copy',
                value: '',
            },
            {
                name: this.translateService.getString('HTML Pages'),
                faIcon: 'fas fa-window-maximize',
                value: 'html',
            },
            {
                name: this.translateService.getString('PDFs'),
                faIcon: 'fas fa-file-pdf',
                value: 'pdf',
            },
            {
                name: this.translateService.getString('Documents'),
                faIcon: 'fas fa-file-alt',
                value: 'document',
            },
        ];
        this.activeTab = '';

        this.getPage();
        this.getLabels();

        this.exports = [
            {
                name: this.translateService.getString('Policy Pages'),
                data: {
                    category: 'policy_pages',
                    category_ref: this.policy.id,
                },
            },
            {
                name: this.translateService.getString('Policy with matching terms'),
                data: {
                    category: 'policy_matching_terms',
                    category_ref: this.policy.id,
                },
            },
        ];
    }

    ngOnDestroy (): void {
        this.monEventService.remove(this.eventId);
    }

    override getPage (): void {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
        };

        if (this.search && this.search !== '') {
            params.search = this.search;
        }

        if (this.activeTab) {
            params.type = this.activeTab;
        }

        const updatedParams = this.updateParamsWithFilters(params);

        this.progress = this.policyRepoService.domainGetPolicyPages(this.policy.id, updatedParams).then((pages: any) => {
            this.pages = pages;
            this.totalIssues = pages.total;
            switch (this.activeTab) {
                case 'html':
                    this.currentPageCount = this.pageCount;
                    break;
                case 'pdf':
                    this.currentPageCount = this.pdfCount;
                    break;
                case 'document':
                    this.currentPageCount = this.documentCount;
                    break;
                default:
                    this.currentPageCount = this.contentCount;
                    break;
            }
        }, () => {});
    }

    onFiltersChanged (changes: any): void {
        this.updateFilters(changes);
        this.getPage();
    }

    onSearchChanged (search) {
        this.search = search;
        this.getPage();
    }

    createOrUpdateLabel (label: any): void {
        this.labelService.createOrUpdateLabel(label);
    }

    trackByIndex (index: number): number {
        return index;
    }
}
